import React, { useState, useEffect } from 'react';
import "./Admin.css"
import PersonalMessageContext from '../components/AdminComponents/PersonalMessageContext';
import PersonalTransferContext from '../components/AdminComponents/PersonalTransferContext';
import BusinessMessageContext from '../components/AdminComponents/BusinessMessageContext';
import BusinessTransferContext from '../components/AdminComponents/BusinessTransferContext';
import BusinessSchedulingContext from '../components/AdminComponents/BusinessSchedulingContext';
import POSContext from '../components/AdminComponents/POSContext';
import AdminCreateBlogPost from '../components/AdminComponents/AdminCreateBlogPost';
import BrowserTestCall from '../components/BrowserTestCall';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import jwt from 'jwt-decode';
import { Button, PageHeader, Skeleton } from '../components/ui/Primitives';
import { memberProfileFromResponse } from '../utils/sessionData';


function Admin({ checkLogin, user }) {
  const [updatedUser, setUpdatedUser] = useState(user);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    async function fetchUserData() {

      setIsLoading(true); // Start loading

      try {
        const jwt_token = localStorage.getItem('jwt_authorization');

        if (!jwt_token) {
          navigate('/');
          return null;
        }

        const decoded_token = jwt(jwt_token);

        if (!decoded_token.is_admin) {
          navigate('/');
          return null;
        }

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_HOST}/user`, { jwt_token });

        if (response.status === 200) {
          setUpdatedUser(memberProfileFromResponse(response.data));
          setIsLoading(false); // Stop loading after user data is set
        }
      } catch (err) {
        console.error("Token verification failed", err);
        setIsLoading(false); // Stop loading in case of error
      }
    }

    fetchUserData();
  }, [user, checkLogin]);


  if (!isLoading && updatedUser) { // Render only when not loading and user data is available
    return (

      <div className="page-content mobile-admin admin-page">
          <PageHeader eyebrow="Administration" title="Operations and governance" description="Manage platform content, monitor operational behavior, and maintain the instruction contexts used across Sayable." actions={<><Button variant="secondary" to="/operations/tester-invitations">Tester invitations</Button><Button variant="secondary" to="/operations/account-cleanup">Account cleanup</Button><Button to="/operations/metrics">Open operations dashboard</Button></>} />

          <div className="admin-content-card">
          <BrowserTestCall mode="admin" />
          <AdminCreateBlogPost user={user} />

          <hr style={{ border: '2px solid #e6ecef', marginTop: '40px', margin: '40px 0 20px 0' }} />
          <PersonalMessageContext user={user} />
          <hr style={{ border: '2px solid #e6ecef', margin: '0' }} />

          <PersonalTransferContext user={user} />

          <hr style={{ border: '2px solid #e6ecef', margin: '0' }} />
          <BusinessMessageContext user={user} />

          <hr style={{ border: '2px solid #e6ecef', margin: '0' }} />

          <BusinessTransferContext user={user} />

          <hr style={{ border: '2px solid #e6ecef', margin: '0' }} />

          <BusinessSchedulingContext user={user} />

          <hr style={{ border: '2px solid #e6ecef', margin: '0' }} />

          <POSContext user={user} />

          <hr style={{ border: '2px solid #e6ecef', margin: '0' }} />
          </div>
        </div>



    );
  } else {

    return (

      <div className="page-content admin-page"><Skeleton width="45%" height={42} /><Skeleton height={400} /></div>


    );
  }


}

export default Admin;
